<template>
  <section class="my-modal-custom">
    <div class="align-center">
      <div class="container-modal">
        <div class="box-modal">
          <div class="modal-title">
            <h1>Ordenar Colunas</h1>
            <feather class="feather-icon" type="x" size="14" @click="$emit('close')" />
          </div>
          <div class="box-container">
            <h1 class="tips">
              Arraste e solte para alterar a ordem das colunas na tabela
            </h1>
            <draggable
              v-model="orderedCollumns"
              class="draggable"
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
            >
              <transition-group
                type="transition"
                :name="!drag ? 'flip-list' : null"
                class="draggable"
              >
                <div v-for="element in orderedCollumns" :key="element.label" class="item-box">
                  {{ element.label }}
                  <b-switch v-model="element.display" size="is-small" />
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
        <div class="btn-containers">
          <div
            class="reset-button"
            @click="(orderedCollumns = defaultData), $emit('ordination', defaultData)"
          >
            <feather class="icon-downloas" type="refresh-ccw" size="15" />
            Resetar
          </div>
          <div class="download-button" @click="$emit('ordination', orderedCollumns)">
            <feather class="icon-downloas" type="layout" size="15" />
            Aplicar
          </div>
        </div>
      </div>
      <div />
    </div>
  </section>
</template>
<script>
import draggable from 'vuedraggable';

export default {
	components: {
		draggable,
	},
	props: {
		defaultData: {
			type: Array,
			default: () => [],
		},
		datadrag: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			drag: false,
			orderedCollumns: this.datadrag,
		};
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
	},
	methods: {
		download() {
			this.$emit('download', { formato: this.formato, nome: this.nome });
		},
	},
};
</script>

<style lang="scss" scoped>
.align-center {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flip-list-move {
  transition: transform 0.1s;
}
.no-move {
  transition: transform 0s;
}
.tips {
  padding: 10px;
  font-size: 13px;
  text-align: center;
}
.my-modal-custom {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.24);
  display: table;
  transition: all 0.1s ease;
  overflow-y: scroll;
  align-items: flex-end;
}
.container-modal {
  position: absolute;
  max-width: 400px;
  border-radius: 5px;
}
.feather-icon {
  background-color: #ff3b30;
  padding: 2px;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: 300ms ease;
}
.feather-icon:hover {
  background-color: #cc342c;
}
.draggable {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  cursor: move;
}
.ghost {
  opacity: 0.5;
  background: #7f44004f;
  cursor: grabbing;
}
.item-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 4px;
  padding-top: 4px;
  margin-bottom: 2px;
  font-size: 12px;
  border-top: 1px solid #dfdfe1c5;
}

.item-box:first-child {
  border-top: 1px solid #dfdfe1c5;
}

.box-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.modal-title {
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #dfdfe1c5;
}
.box-modal {
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 90%;
  border-radius: 10px;
}
.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #007f00;
  padding: 10px;
    width: 100%;
  margin-top: 10px;
  border-radius: 10px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  transition: 500ms ease;
  font-size: 14px;
}
.download-button:hover {
  background-color: #005c00;
}
.btn-containers {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
}

.reset-button {
  background-color: #ff3b30;
  display: flex;
 width: 100%;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  transition: 500ms ease;
  font-size: 14px;
}
.reset-button:hover {
  background-color: #cc342c;
}
.switch {
  margin: 0px !important;
}
.icon-downloas {
  margin-right: 5px;
}

@media screen and (max-height: 663px) {
  .item-box {
    width: 50%;
  }
  .container-modal {
  max-width: 100vh;
}
.btn-containers {
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}
.reset-button {
  width: 49%;
}
.download-button {
  width: 49%;
}
}
</style>
